var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var ArrowDown = function ArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12 7",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "ArrowDown_a",
    d: "M349.3 804l1.36 1.33-5.83 5.67-5.83-5.67 1.36-1.33 4.47 4.35z"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#ArrowDown_a",
    transform: "translate(-339 -804)"
  }));
};

export default ArrowDown;